export default "__VITE_ASSET__83246381__"